import React, { useState } from "react";
import { useSelector } from "react-redux";
import "./Profile.css";
import type { RootState } from "../../app/store";
import { changePasswordApi } from "../../services/authService";
import PasswordInput from "../../components/PasswordInput";

const Profile = () => {
  const { user, role, displayName } = useSelector((state: RootState) => state.auth);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [message, setMessage] = useState<string | null>(null);

  const roleLabel = role === "partner" ? "Partner" : "Admin";

  const handleChangePassword = async (e: React.FormEvent) => {
    e.preventDefault();
    setMessage(null);

    if (newPassword.length < 8) {
      setStatus("error");
      setMessage("New password must be at least 8 characters.");
      return;
    }

    if (newPassword !== confirmPassword) {
      setStatus("error");
      setMessage("New passwords do not match.");
      return;
    }

    setStatus("loading");
    try {
      const result = await changePasswordApi({ currentPassword, newPassword });
      setStatus("success");
      setMessage(result.message);
      setCurrentPassword("");
      setNewPassword("");
      setConfirmPassword("");
    } catch (err: unknown) {
      setStatus("error");
      setMessage(err instanceof Error ? err.message : "Failed to change password");
    }
  };

  return (
    <div className="profile-page">
      <div className="profile-card">
        <h1 className="profile-title">Profile</h1>

        <div className="profile-row">
          <span className="label">Name</span>
          <span className="value">{displayName || "—"}</span>
        </div>

        <div className="profile-row">
          <span className="label">Email</span>
          <span className="value">{user}</span>
        </div>

        <div className="profile-row">
          <span className="label">Role</span>
          <span className="value">{roleLabel}</span>
        </div>
      </div>
     {role === "admin" && (

     
      <div className="profile-card profile-card--form">
        <h2 className="profile-subtitle">Change Password</h2>
        <p className="profile-hint">
          Update your admin account password.
          {/* {role === "partner"
            ? "Update your password after logging in with credentials from email."
            : "Update your admin account password."} */}
        </p>

        {message && (
          <p className={`profile-feedback profile-feedback--${status}`}>{message}</p>
        )}

        <form className="profile-form" onSubmit={handleChangePassword}>
          <label>
            Current password
            <PasswordInput
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              required
              disabled={status === "loading"}
            />
          </label>
          <label>
            New password
            <PasswordInput
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              minLength={8}
              disabled={status === "loading"}
            />
          </label>
          <label>
            Confirm new password
            <PasswordInput
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              minLength={8}
              disabled={status === "loading"}
            />
          </label>
          <button type="submit" className="profile-submit" disabled={status === "loading"}>
            {status === "loading" ? "Saving..." : "Change Password"}
          </button>
        </form>
      </div>
      )}
    </div>
  );
};

export default Profile;
